import { authRequest } from './client';
import {
  type ListWithdrawalsParams,
  type ListWithdrawalsResponse,
  type RejectWithdrawalInput,
  type WithdrawalListItem,
} from './types';

// ─── backoffice-api withdrawals client ─────────────────────────────────────
//
// Thin fetch wrappers around backoffice-api's `/v1/withdrawals` endpoints
// (Feature 030 Task 6). `listWithdrawals`/`getWithdrawal` are FINANCE_VIEWER
// OR CONFIG_MANAGER; `approveWithdrawal`/`rejectWithdrawal` are
// CONFIG_MANAGER-only — mirrors gas-station.ts's read/write role split.

export function listWithdrawals(params: ListWithdrawalsParams = {}): Promise<ListWithdrawalsResponse> {
  const query = new URLSearchParams();
  if (params.page !== undefined) query.set('page', String(params.page));
  if (params.pageSize !== undefined) query.set('pageSize', String(params.pageSize));
  if (params.status !== undefined) query.set('status', params.status);
  if (params.merchantId !== undefined) query.set('merchantId', params.merchantId);
  const qs = query.toString();
  return authRequest<ListWithdrawalsResponse>(`/withdrawals${qs ? `?${qs}` : ''}`);
}

export function getWithdrawal(id: string): Promise<{ data: WithdrawalListItem }> {
  return authRequest<{ data: WithdrawalListItem }>(`/withdrawals/${id}`);
}

// The controller's approve route takes no `@Body()` at all — `authRequest`'s
// underlying `fetch` call tolerates `{ method: 'POST' }` with no `body` key
// present (fetchRaw only sets `Content-Type: application/json` when
// `init.body !== undefined`), so this omits `body` entirely rather than
// sending an empty-object placeholder.
export function approveWithdrawal(id: string): Promise<{ data: WithdrawalListItem }> {
  return authRequest<{ data: WithdrawalListItem }>(`/withdrawals/${id}/approve`, { method: 'POST' });
}

export function rejectWithdrawal(
  id: string,
  input: RejectWithdrawalInput,
): Promise<{ data: WithdrawalListItem }> {
  return authRequest<{ data: WithdrawalListItem }>(`/withdrawals/${id}/reject`, {
    method: 'POST',
    body: JSON.stringify(input),
  });
}
